<router-outlet />
<ngx-spinner
  name="pageLoading"
  bdColor="rgba(0,0,0,0.3)"
  [fullScreen]="true"
  size="medium"
  type="ball-spin-clockwise"
></ngx-spinner>
